import { clamp } from "lodash-es";
import { MAX_SCALE, MIN_SCALE } from "web_myplann/Chat/constants";
import { distanceBetween } from "web_myplann/Chat/Helpers/PinchZoom/distanceBetween";
import { midpointOf } from "web_myplann/Chat/Helpers/PinchZoom/midpointOf";
import { zoomAroundPoint } from "web_myplann/Chat/Helpers/PinchZoom/zoomAroundPoint";
import type {
	PinchStart,
	Point,
	Transform,
} from "web_myplann/Chat/Types/pinchZoom";

export const getPinchTransform = (
	start: PinchStart,
	first: Point,
	second: Point,
): Transform => {
	const ratio =
		start.distance > 0 ? distanceBetween(first, second) / start.distance : 1;

	return zoomAroundPoint(
		start.transform,
		midpointOf(first, second),
		clamp(start.transform.scale * ratio, MIN_SCALE, MAX_SCALE),
	);
};
